module.exports = __webpack_public_path__ + "static/media/sf-cover@2x.aedf45b9.png";